// extracted by mini-css-extract-plugin
export default {"textArea":"styles_textArea__v7YyL","label":"styles_label__fw4CW","error":"styles_error__-hXO1","input":"styles_input__s-KSw","hasError":"styles_hasError__raNzb"};